export default __webpack_public_path__ + "static/media/report.a3a4e014.svg";